import { Component, Input, OnInit, output, input, ChangeDetectionStrategy } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ThemePalette } from '@angular/material/core';
import { JkBaseComponent } from '../jkbase/jkbase.component';

@Component({
    selector: 'app-jkswitch',
    templateUrl: './jkswitch.component.html',
    styleUrls: ['./jkswitch.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ MatSlideToggleModule],
})
export class JkswitchComponent extends JkBaseComponent  implements OnInit {
  override comType: string = 'jkswitch';
  //@Input() width = 100;
  readonly switchedOnText = input('是');
  readonly switchedOffText = input('否');
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() value: string = 'N';
  readonly valueChange = output<string>();
  onValueChange(newValue: boolean) {
    let yn: string = newValue ? 'Y' : 'N';
    this.valueChange.emit(yn);
  }
  get valueBoolean(): boolean {
    return this.value === 'Y';
  }
  set valueBoolean(value: boolean) {
    this.value = value ? 'Y' : 'N';
  }
  get checked(): boolean {
    return this.value === 'Y';
  }
  set checked(value: boolean) {
    this.value = value ? 'Y' : 'N';
  }
  color: ThemePalette = 'accent';
  constructor() {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
  }

}
